import { render, staticRenderFns } from "./LlLawList.vue?vue&type=template&id=0bdd63f8"
import script from "./LlLawList.vue?vue&type=script&lang=js"
export * from "./LlLawList.vue?vue&type=script&lang=js"
import style0 from "./LlLawList.vue?vue&type=style&index=0&id=0bdd63f8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports